module.exports = __webpack_public_path__ + "img/windows-load-certificate.eacb38ea.gif";